import { render, staticRenderFns } from "./ProductDiscontinued.vue?vue&type=template&id=4d463d2a&lang=pug"
import script from "./ProductDiscontinued.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDiscontinued.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports